import React from "react";
import Hero from "../components/hero";
import WhatWeDo from "../components/whatwedo";
import Acheivements from "../components/achievements";
import Projects from "../components/projects";
import Contact from "../components/contact";
import PresidentWord from "../components/president";
import JoinUs from "../components/join";
import WeServe from "../components/we-serve";

export default function home() {
  return (
    <>
      <div className="circle-left"></div>
      <div className="circle-right"></div>
      <Hero />
      <WhatWeDo />
      <WeServe />
      <Acheivements />
      <PresidentWord />
      <Projects />
      <Contact />
      <JoinUs />
    </>
  );
}
